import MyNavbar from "../../component/Navbar/Navbar";
import Appcontent from "../../appcomponent/appcontent/appcontent";
import Feature from "../../appcomponent/feature/Feature";
import Appneed from "../../appcomponent/needs/Appneed";
import Appcycle from "../../appcomponent/appcycle/Appcycle";
import Footer from "../../component/Footer/Footer"
const Appdev =()=>{
    return (
        <>
        <MyNavbar/> 
        <Appcontent/>
        <Feature/>
        <Appneed/>
        <Appcycle/>
        <Footer/>
        </>
    )
}

export default Appdev